import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from 'src/app/core/store/store';
import { User } from 'src/app/shared/models/user.model';
import { DashboardService } from 'src/app/shared/services/dashboard.service';
import { DashboardService as selfDashboardService } from '../../services/dashboard.service'
import { ToastrService } from 'ngx-toastr';
// import { HandleSubscription } from 'src/app/shared/utils/handle-subscription';
// import { takeUntil } from 'rxjs/internal/operators/takeUntil';
// import { Subscription } from 'rxjs';
import { PathwayService } from 'src/app/shared/services/pathway.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { EventsService } from 'src/app/shared/services/events.service';
import { Subject } from 'rxjs';

var inactivatetime = 0;
var intervalID;
declare var TimeMe;

import { typeofExpr } from '@angular/compiler/src/output/output_ast';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-dashboard-program-new',
  templateUrl: './dashboard-program-new.component.html',
  styleUrls: ['./dashboard-program-new.component.scss']
})
export class DashboardProgramNewComponent implements OnInit, OnChanges, OnDestroy {
  // @Input() program: any;
  @Input() activationInfo: any;
  prog: any;
  program: any;
  user: User;
  showMobal = false;
  modelValue = false;
  modalData: any;
  dateFormat = 'h:mm a, d MMM y';
  courseStartParams: any;
  zoomStartParams: any;
  programActivationId: any;
  // zoomSubscription: Subscription;
  // courseSubscription: Subscription;
  lockedCardMsg = { msg: '', date: null, courseName: '', courseId: null, type: '' };
  showMasterclass = false;
  masterClassModalData;
  masterVideoObj;
  preTitle = 'basecamp';
  @Input() progCurrentItem: any;
  optionalModal = false;
  dashboardTimespent:any;
  timeTrackingObj = {};
  userActivity;
  userInactive: Subject<any> = new Subject();
  timeConverted = false;
  newProgramData: Array<any> = []

  todayDate = new Date().toLocaleDateString('en-US');
  @Input() isProgramCompletionDatePassed;
  dynamicHabitDrillNomenclature= 'Habit Drill';
  constructor(private dashboardService: DashboardService, private router: Router, private toaster: ToastrService, private store: Store,
    private ps: PathwayService, private cs: CommonService, private eventsService: EventsService,
    private selfDashboardService : selfDashboardService,private datePipe:DatePipe) {
      this.setTimeout();
      this.userInactive.subscribe(() =>{
        // console.log('user has been inactive for 15min');
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.progCurrentItem) {
      this.blockItemNavigation();
    }
  }

    getTimeDifference(endDate: Date,startDate: Date): string {
        const start = new Date(startDate);
        const end = new Date(endDate);
        // console.log(endDate, 'endDateendDate')
        const timeDiffMs = end.getTime() - start.getTime();
        const hours = Math.floor(timeDiffMs / 3600000); // 1 hour = 3600000 milliseconds
        const minutes = Math.floor((timeDiffMs % 3600000) / 60000); // 1 minute = 60000 milliseconds
        if(hours > 0){
          return `${hours} hours, ${minutes} minutes`;
        }else{
        return `${minutes} minutes`;

        }

    }


  ngOnInit(): void {
    TimeMe.initialize({
	    currentPageName: "dashboardPage", // current page
    });
    TimeMe.startTimer();
    this.store.select('programData').pipe().subscribe((activation: any) => {
      if(activation) {
        this.prog = activation;
        this.program = activation
      }
    });
    this.store.select('IPJProgram').pipe().subscribe((activation: any) => {
      if(activation) {
        this.programActivationId = activation[0]['programActivationId']
        this.timeTrackingObj['programActivationId'] = activation[0]['programActivationId'];
      }
    })
    if (this.program.length) {
      // this.addMasterClassEndDate();
      this.prog = this.program;
      
    // this.getActivationDashboard(this.program[0]['programActivationId'], this.prog['_id'])
      // console.log(this.prog)
      if(this.user && this.user['isTimeZoneConfirmed']){
        this.prog['dashboard'].forEach(element => {
          console.log("Title-- : ",element.title, " : --Date-- : " , element.course_StartDate, " : --timeZone-- : " , this.user['timeZone'])
          if(element.masterClassObjects.length>0 && element.masterClassObjects[0].date){
            element.masterClassObjects[0].date = this.convertMasterClassTime(element.masterClassObjects[0].date, this.user['timeZone'])
            element.masterClassObjects[0].endDate = this.convertMasterClassTime(element.masterClassObjects[0].endDate, this.user['timeZone'])
          }
          if(element.status.msg.length>0 && this.prog['activation']['courseUnlockType']=='DATE'){
            let msgParts =element.status.msg.split('on');
            element.status.msg =msgParts[0] + ' on ' + this.convertTime(element.course_StartDate, this.user['timeZone'])
          }

        });
      }
      this.timeTrackingObj['eventType'] = 'DASHBOARD';
      this.timeTrackingObj['organization'] = this.activationInfo['organization']
      if(this.activationInfo['enableCustomHabitDrillNomenClature']){
        this.dynamicHabitDrillNomenclature = this.activationInfo['customHabitNomenclature']
      }
      // create property assessmentExercises without editor question for assessment block to show correct questions
      if(this.prog) {
        // for (let i = 0; i < this.prog.length; i++) {
        //   if((this.prog[i].type == 'ASSESSMENT') || (this.prog[i].type == 'PRE') || (this.prog[i].type == 'POST')) {
        //     // let exercises = this.prog[i].exercise.pages[0].elements.filter(v => v.elementType != 'EDITOR');
        //     this.prog.dashboard[i].exercise.pages[0]['totalQuestions'] = exercises.length;
        //   }
        // }
      }
    }
    this.store.select('user').subscribe((user: any) => {
      this.user = user;
      if(user && user['isTimeZoneConfirmed']){
        this.program.forEach(element => {
          // if(element.masterClassObjects.length>0 && element.masterClassObjects[0].date && !this.timeConverted){
          //   element.masterClassObjects[0].date = this.convertMasterClassTime(element.masterClassObjects[0].date, this.user['timeZone'])
          //   element.masterClassObjects[0].endDate = this.convertMasterClassTime(element.masterClassObjects[0].endDate, this.user['timeZone'])
          //   this.timeConverted=true
          // }
          if(element.status.msg.length>0 && this.activationInfo['courseUnlockType']=='DATE'){
            let msgParts =element.status.msg.split('on');
            element.status.msg =msgParts[0] + ' on ' + this.convertTime(element.course_StartDate, this.user['timeZone'])
          }

        });
      }
    });
  }

  convertMasterClassTime(time,zone){
    var d = new Date(time);
    var inititalDate = new Date(d.setUTCMinutes(d.getUTCMinutes() + d.getTimezoneOffset()))
    // console.log(new Date(inititalDate.setUTCMinutes(inititalDate.getUTCMinutes() + this.convertMinutes(zone))).toISOString())
    return new Date(inititalDate.setUTCMinutes(inititalDate.getUTCMinutes() + this.convertMinutes(zone))).toISOString();
  }

  convertTime(time, zone){
    var d = new Date(time);
    var inititalDate = new Date(d.setUTCMinutes(d.getUTCMinutes() + d.getTimezoneOffset()))
    // console.log('------->New', new Date(inititalDate.setUTCMinutes(inititalDate.getUTCMinutes() + this.convertMinutes(zone))).toLocaleDateString('en', {weekday : 'long', year: 'numeric', month: 'long' , day: '2-digit' ,hour: '2-digit', minute: '2-digit', second: '2-digit'}))
    return new Date(inititalDate.setUTCMinutes(inititalDate.getUTCMinutes() + this.convertMinutes(zone))).toLocaleDateString('en', {weekday : 'long', year: 'numeric', month: 'long' , day: '2-digit' ,hour: '2-digit', minute: '2-digit', second: '2-digit'})
  }
  convertMinutes(time){
    var timeParts = time.split(':');
    return Number(timeParts[0]) * 60 + Number(timeParts[1]);
  }

  navigateToPreTest(item?) {
    if(item && item.isOptionalToComplete && !this.optionalModal && (!item.status.skipOptionalBlock && !item.status.started)) {
      this.optionalModal = true;
      this.progCurrentItem = item;
      return;
    }
    this.router.navigate([`/benchmarking/pre-test`]);
    // capture event
    try {
      this.capturePreTestEvents(item);
    } catch (err) {
      console.log(err);
    }
  }

  openModal(value, item) {
    this.modelValue = value;
    if (this.modelValue) {
      let courseObj;
      if (this.courseStartParams) {
        // if course started from banner
        courseObj = { activationId: this.activationInfo.programActivationId, programDashboardId: this.progCurrentItem.programDashboardId, activationDashboardType: 'COURSE', courseId: this.progCurrentItem.courseId };
        // courseObj = { activationId: this.courseStartParams.activationId, programDashboardId: this.courseStartParams.programDashboardId, activationDashboardType: 'COURSE', courseId: this.courseStartParams.courseId };
      } else {
        // if course started from card
        courseObj = { activationId: this.activationInfo.programActivationId, programDashboardId: item.programDashboardId, activationDashboardType: 'COURSE', courseId: item.courseId };
      }
      this.dashboardService.startCourse(courseObj).subscribe((res) => {
        if (res.data) {
          const url = this.router.serializeUrl(
            this.router.createUrlTree([`/player/${item.courseId}`])
          );
          window.open(url, '_self');
          // capture event
          this.captureStartCourseEvent(item);
        }
      })

    }
  }

  showModal(item) {
    this.modalData = item;
    if (this.modalData.courseDisableIntroVideo == true) {
      this.showMobal = false;
    } else {
      this.showMobal = true;
      // capture event
      try {
        if(this.user && this.prog && item.type == 'COURSE') {
          let eventData = { user: this.user, program: this.prog };
          let courseObj = this.prog.dashboard.find(x => x.type == 'COURSE' && x._id == item._id);
          if(courseObj) {
            eventData['courseObj'] = courseObj;
          }
          this.eventsService.watchCourseIntroEvent(eventData);
        }
      } catch (err) {
        console.log(err);
      }
    }
  }

  navigateToPostTest(item?) {
    if(item && item.isOptionalToComplete && !this.optionalModal && (!item.status.skipOptionalBlock && !item.status.started)) {
      this.optionalModal = true;
      this.progCurrentItem = item;
      return;
    }
    this.router.navigate([`/benchmarking/post-test`]);
    try {
      this.capturePostTestEvents(item);
    } catch (err) {
      console.log(err);
    }
  }

  startCourse(type, courseId, progDashboardId, el, event?) {
    if(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    if(el && el.isOptionalToComplete && !this.optionalModal && (!el.status.skipOptionalBlock && !el.status.started)) {
      this.optionalModal = true;
      this.progCurrentItem = el;
      return;
    }
    if (!el.status.started) {
      this.modalData = el;
      if (el.courseDisableIntroVideo) {
        this.showMobal = false;
        this.modelValue = true;
      } else {
        this.showMobal = true;
        return;
      }
    }
    if (this.modelValue) {
      let courseObj = { activationId: this.activationInfo.programActivationId, programDashboardId: progDashboardId, activationDashboardType: type, courseId: courseId };
      this.dashboardService.startCourse(courseObj).subscribe((res) => {
        if (res && res.data) {
          // this.getProgramActivation();
          // const url = this.router.serializeUrl(
          //   this.router.createUrlTree([`/player/${courseId}`])
          // );
          this.router.navigate([`/player/${courseId}`])
          // this.cs.reloadRoute('/dashboard');
          // capture event
          this.captureStartCourseEvent(el);
        }
      })
    }
    if (el.status.started) {
      // capture event
      this.captureResumeReviseCourseEvent(el);
      // const url = this.router.serializeUrl(
      //   this.router.createUrlTree([`/player/${courseId}`])
      // );
      this.router.navigate([`/player/${courseId}`])
    }
  }

  startZoom(masterClassObjectId, progDashboardId, item) {
    if(item && item.isOptionalToComplete && !this.optionalModal && (!item.status.skipOptionalBlock && !item.status.started)) {
      this.optionalModal = true;
      this.progCurrentItem = item;
      return;
    }
    if ((item && item.status && item.status.islock) || item.status.upcoming || (item.status.isMeetingEnd && (!item.masterClassObjects[0].recordedLink || item.masterClassObjects[0].recordedLink == ''))) {

      return;
    }
    if ((item.status.isMeetingEnd && item.masterClassObjects[0].recordedLink) || (item.masterClassObjects[0].recordedLink && item.masterClassObjects[0].recordedLink != '')) {

      const videoInfo =  { 'userId': this.user._id, 'programActivationId': this.programActivationId, 'programDashboardId': progDashboardId, 'masterClassObjectId': masterClassObjectId, }
      this.dashboardService.watchVideo(videoInfo).subscribe((res:any)=>{
        console.log(res.msg);
      },err=>{
        console.log(err);
      })
      if (this.zoomStartParams) {
        // if meeting started from banner
        this.masterVideoObj = { activationId: this.zoomStartParams.activationId, programDashboardId: this.zoomStartParams.programDashboardId, activationDashboardType: 'MASTERCLASS', masterClassObjectId: this.zoomStartParams.item.masterClassObjects[0]._id, viewedTime: item.viewedTime,masterClassDuration: item.masterClassObjects[0].recordedLinkDuration };
      } else {
        this.masterVideoObj = { activationId: this.programActivationId, programDashboardId: progDashboardId, activationDashboardType: 'MASTERCLASS', masterClassObjectId: masterClassObjectId, viewedTime: item.viewedTime,organization:this.activationInfo['organization'],masterClassDuration: item.masterClassObjects[0].recordedLinkDuration};
      }
      this.masterClassModalData = item;
      this.showMasterclass = true;
      // capture video watch event
      try {
        this.captureWatchMasterclassVideoEvent(item);
      } catch (err) {
        console.log(err);
      }
    }
    // master class start api
    else if (!item.status.started || (!item.status.isMeetingEnd && (item.status.progress < 100) && item.status.started)) {

      let masterObj;
      if (this.zoomStartParams) {
        // if meeting started from banner
        masterObj = { activationId: this.zoomStartParams.activationId, programDashboardId: this.zoomStartParams.programDashboardId, activationDashboardType: 'MASTERCLASS', masterClassObjectId: this.zoomStartParams.item.masterClassObjects[0]._id };
      } else {
        // if meeting started from card
        masterObj = { activationId: this.programActivationId, programDashboardId: progDashboardId, activationDashboardType: 'MASTERCLASS', masterClassObjectId: masterClassObjectId };
      }
      // this.store.set('zoomStart', null)
      // this.zoomSubscription && this.zoomSubscription.unsubscribe();
      this.dashboardService.startMasterclass(masterObj).subscribe((res) => {
        if (res && res.data) {
          // this.getProgramActivation();
          this.startZoomMeeting(item);
          this.cs.reloadRoute('/dashboard');
        }
      });
    } else {
      this.startZoomMeeting(item);
    }

  }

  startZoomMeeting(item) {
    let meetingNum;
    // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    //   this.toaster.info("Please log in through your laptop/desktop to access this session");
    //   return;
    // }
    if (item && item.masterClassObjects.length) {
      meetingNum = item.masterClassObjects[0].meetingId;
      // get zoom meeting signature from API
      this.generateZoomSign(meetingNum, item);
    }
  }

  generateZoomSign(meetingNum, item?) {
    this.dashboardService.generateZoomSignature({ meetingNumber: meetingNum, role: 0 }).subscribe((res) => {
      if (res && res.data && res.data.signature) {
        localStorage.setItem('zoomSign', res.data.signature);
        this.zoomMeetingDataSet(meetingNum, item);
      } else {
        this.zoomMeetingDataSet(meetingNum, item);
      }
    }, (error) => {
      console.log(error);
      this.zoomMeetingDataSet(meetingNum, item);
      // this.toaster.error("Zoom signature issue");
    });
  }

  zoomMeetingDataSet(meetingNum, item?) {
    localStorage.setItem('email', this.user.email);
    localStorage.setItem('meetingId', meetingNum);
    localStorage.setItem('userName', `${this.user.firstName} ${this.user.lastName}`);
    localStorage.setItem('pathwayUrl', window.location.href);
    window.open(item.joinUrl, '_blank');
    // capture event
    try {
      this.captureAttendMasterclassEvent(item);
    } catch (err) {
      console.log(err);
    }
  }

  closeModel(value) {
    if (value) {
      // this.store.set('courseStart', null);
      this.showMobal = false;
      if(this.modalData.type == 'COURSE') {
        this.openModal(value, this.modalData)
      } else if(this.modalData.type == 'INTEGRATION') {
        this.startIntegration('dashboard/hiration', this.modalData, true)
      }
    } else {
      this.showMobal = value;
      // capture event course close modal
      try {
        if(this.modalData.type == 'COURSE') {
          this.captureStopCourseIntroEvent();
        }
      } catch (err) {
        console.log(err);
      }
    }
  }

  navigateLinkedIn(url) {
    window.open(url, '_blank');
  }

  habitDrillDetails(item, habit) {
    if (habit && habit.courseHabitDrillId) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/dashboard/habit-drills/${habit?.courseHabitDrillId}`])
      );
      window.open(url, '_self');
      // capture event
      try {
        if(this.user && this.program && this.program[0]) {
          let eventData = { user: this.user, activationData: this.program[0], item: item, habit: habit}
          this.eventsService.habitDrillTaggedEvent(eventData);
        }
      } catch (err) {
        console.log(err);
      }
    }
  }

  getProgramActivation() {
    // this.store.set('courseStart', null);
    this.dashboardService.getProgramActivation().subscribe((res) => {
      if (res && res['data']) {
        this.store.set('activation', res['data']);
      }
    });
  }

  /* lockMsgOnCard() {
    let courses = [],
      lockedCourses = [],
      unLockedCourses = [];

    courses = this.prog.dashboard.filter(v => v.type == 'COURSE');

    courses = courses.sort((a, b) => a.order - b.order);
    lockedCourses = courses.filter(v => v.status.islock == true);
    unLockedCourses = courses.filter(v => v.status.islock == false);
    let preAssessment = this.prog.dashboard.find(v => v.type == 'PRE');
    if (preAssessment) {
      this.preTitle = (preAssessment.title) ? preAssessment.title : 'basecamp';
    }
    if ((courses.length == lockedCourses.length) && courses.length > 0) {
      if (preAssessment && (preAssessment.status.progress == 100) && this.prog.activation.courseUnlockType == 'DATE') {
        this.lockedCardMsg.msg = `This course will unlock on`;
        this.lockedCardMsg.courseId = lockedCourses[0].courseId;
        this.lockedCardMsg.date = new Date(lockedCourses[0].course_StartDate);
        this.lockedCardMsg.type = 'DATE';
      } else if (preAssessment && (preAssessment.status.progress != 100) && this.prog.activation.courseUnlockType == 'DATE') {
        if (new Date().getTime() > new Date(lockedCourses[0].course_StartDate).getTime()) {
          this.lockedCardMsg.msg = `This course will unlock after completing the ${this.preTitle}`;
          this.lockedCardMsg.courseId = lockedCourses[0].courseId;
          this.lockedCardMsg.type = 'PRE';
        } else {
          this.lockedCardMsg.msg = `This course will unlock on`;
          this.lockedCardMsg.courseId = lockedCourses[0].courseId;
          this.lockedCardMsg.date = new Date(lockedCourses[0].course_StartDate);
          this.lockedCardMsg.type = 'DATE';
          this.lockedCardMsg['dateNotPassed'] = true;
        }
      } else if ((preAssessment === undefined) && this.prog.activation.courseUnlockType == 'DATE') {
        this.lockedCardMsg.msg = `This course will unlock on`;
        this.lockedCardMsg.courseId = lockedCourses[0].courseId;
        this.lockedCardMsg.date = new Date(lockedCourses[0].course_StartDate);
        this.lockedCardMsg.type = 'DATE';
      }
      else {
        this.lockedCardMsg.msg = `This course will unlock after completing the ${this.preTitle}`;
        this.lockedCardMsg.courseId = lockedCourses[0].courseId;
        this.lockedCardMsg.type = 'PRE';
      }
    } else if (((lockedCourses.length > 0) && (lockedCourses.length < courses.length)) && this.prog.activation.courseUnlockType == 'SEQUENCE') {
      if (unLockedCourses.length > 0) {
        this.lockedCardMsg.msg = `Complete ${unLockedCourses[unLockedCourses.length - 1].title} to unlock this course`;
        this.lockedCardMsg.courseId = lockedCourses[0].courseId;
        this.lockedCardMsg.type = 'SEQUENCE';
        this.lockedCardMsg.courseName = unLockedCourses[unLockedCourses.length - 1].title;
      }
    } else if (((lockedCourses.length > 0) && (lockedCourses.length < courses.length)) && this.prog.activation.courseUnlockType == 'DATE') {
      this.lockedCardMsg.msg = `This course will unlock on`;
      this.lockedCardMsg.courseId = lockedCourses[0].courseId;
      this.lockedCardMsg.date = new Date(lockedCourses[0].course_StartDate);
      this.lockedCardMsg.type = 'DATE';
    }
    this.compareDate();
  } */

  /* compareDate() {
    if (this.prog.activation.courseUnlockType == 'DATE') {
      let preAssessment = this.prog.dashboard.find(v => v.type == 'PRE');
      this.prog.dashboard.map((c) => {
        if (c.type == 'COURSE')
          c['isDatePassed'] = new Date().getTime() > new Date(c.course_StartDate).getTime();
        c['isPreDone'] = (preAssessment && (preAssessment.status.progress == 100)) ? true : false;
      });
    }
  } */

  closeMasterClassModal(value) {
    this.showMasterclass = false;
    if (value) {
      window.location.reload();
    } else {
      this.cs.reloadRoute('/dashboard');
      // this.getProgramActivationOnZoom();
      // this.store.set('zoomStart', null);
    }
  }

  /* getProgramActivationOnZoom() {
    this.dashboardService.getProgramActivation().subscribe((res) => {
      if (res && res['data']) {
        this.prog = res['data'][0]['program'];
        this.store.set('activation', res['data']);
      }
    });
  } */


  goToReportCertificate() {
    if (this.activationInfo && this.activationInfo.progress && (this.activationInfo.progress == 100) && (this.activationInfo.isFeedbackSubmitted || !this.activationInfo.enableProgramFeedback)) {
      if(this.activationInfo.enableProgramCertificate && !this.activationInfo.showProgramPerformanceReport) {
        // show program completion modal
        this.goToCertificate(this.activationInfo.programCertificate.certificateId)
      }
      if(this.activationInfo.enableProgramCertificate && this.activationInfo.showProgramPerformanceReport ||    !this.activationInfo.enableProgramCertificate && this.activationInfo.showProgramPerformanceReport){
        this.router.navigate(['/dashboard/reports-certificate']);
      }
     
      //  capture event
      try {
        if(this.user && this.program[0]) {
          let eventData = { user: this.user, activationData: this.program[0] };
          this.eventsService.viewCertificateTranscriptEvent(eventData);
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      return;
    }
  }

  goToCertificate(id) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/program-certificate/${id}`])
    );
    window.open(url, '_blank');
    // capture event
    try {
      if(this.user && this.program[0]['program'].activation && this.program[0]['program'].activation.length){
        let eventData = { 'user': this.user, 'activationData': this.program[0]['program'].activation[0] }
        this.eventsService.viewCertificateEvent(eventData);
      }
    } catch (err) {
      console.log(err);
    }
  }

  addMasterClassEndDate() {
    // find masterclass endDate from duration
    this.program.map((v) => {
      if (v.type == "MASTERCLASS" && v.masterClassObjects && v.masterClassObjects.length) {
        v.masterClassObjects[0].endDate = this.addMinutes(new Date(v.masterClassObjects[0].date), +v.duration);
      }
    });
    // this.prog = this.program[0]['program'];
  }

  addMinutes(date, minutes) {
    // convert minutes to miliseconds
    return new Date(date.getTime() + minutes * 60000);
  }

  /**
   * Start course/masterclass/pre/post/assessment/hiration & show optional modal
   */
   blockItemNavigation() {
    if (this.progCurrentItem) {
      if (this.progCurrentItem['isOptionalToComplete'] && !this.progCurrentItem.status.skipOptionalBlock && !this.progCurrentItem.status.started) {
        this.optionalModal = true
      }
      else if (!this.progCurrentItem['isOptionalToComplete']) {
        this.startBlockItem(this.progCurrentItem.type);
      }
      else if (this.progCurrentItem['isOptionalToComplete'] && this.progCurrentItem.status.started) {
        this.startBlockItem(this.progCurrentItem.type);
      }
    }
  }

  startBlockItem(type) {
    switch (type) {
      case 'PRE':
        this.navigateToPreTest();
        break;
      case 'POST':
        this.navigateToPostTest();
        break;
      case 'COURSE':
        this.startCourse('COURSE', this.progCurrentItem.courseId, this.progCurrentItem.programDashboardId, this.progCurrentItem);
        break;
      case 'MASTERCLASS':
        this.startZoom(this.progCurrentItem.masterClassObjects[0]._id, this.progCurrentItem.programDashboardId, this.progCurrentItem);
        break;
      case 'ASSESSMENT':
        this.navigateToAssessment(this.progCurrentItem);
        break;
      case 'INTEGRATION':
        this.startIntegration('dashboard/hiration', this.progCurrentItem);
        break;
      default:
        break;
    }
  }

  // Skip current optional item
  skipOptionalBlock() {
    this.optionalModal = false;
    switch (this.progCurrentItem.type) {
      case 'PRE':
        this.skipExerciseBlock('PRE',);
        break;
      case 'POST':
        this.skipExerciseBlock('POST');
        break;
      case 'COURSE':
        this.skipCourse();
        break;
      case 'MASTERCLASS':
        this.skipMasterClass();
        break;
      case 'ASSESSMENT':
        this.skipAssessmentBlock();
        break;
      case 'INTEGRATION':
        this.skipIntegration();
        break;
      default:
        break;
    }
  }

  // Start current optional item
  startCurrentBlockItem() {
    this.startBlockItem(this.progCurrentItem.type);
    this.optionalModal = false;
  }

  // Hide optional modal
  optionalModalHide(v) {
    this.optionalModal = v;
  }

  /**
  * Save pre, post & assessment skip value for optional block
  */
  skipExerciseBlock(type) {
    let obj = {
      programId: this.activationInfo.programId,
      activationId: this.activationInfo.programActivationId,
      exerciseType: type,
      exerciseId: this.progCurrentItem.exerciseId,
      answers: [], timeSpent: 0, skipOptionalBlock: true
    }
    this.ps.saveBenchmarkingPrePostExer(obj).subscribe((res) => {
      console.log(res);
      if (res) {
        this.navigateToNextItem();
      }
    });
  }

  /**
   * If course is optional then skip to next item
   */
  skipCourse() {
    let courseObj = { activationId: this.activationInfo.programActivationId, programDashboardId: this.progCurrentItem.programDashboardId, activationDashboardType: 'COURSE', courseId: this.progCurrentItem.courseId, skipOptionalBlock: true };
    this.dashboardService.startCourse(courseObj).subscribe((res) => {
      if (res && res.data) {
        this.navigateToNextItem();
      }
    })
  }

  /**
   * If masterclass is optional then skip to next item
   */
  skipMasterClass() {
    let masterObj = { activationId: this.activationInfo.programActivationId, programDashboardId: this.progCurrentItem.programDashboardId, activationDashboardType: 'MASTERCLASS', masterClassObjectId: this.progCurrentItem.masterClassObjects[0]._id, skipOptionalBlock: true };
    this.dashboardService.startMasterclass(masterObj).subscribe((res) => {
      if (res && res.data) {
        this.navigateToNextItem();
      }
    });
  }

  /**
   * If integration is optional then skip to next item
   */
   skipIntegration() {
    let payload = {
      activationId : this.program && this.program.length ? this.activationInfo.programActivationId : null,
      programDashboardId : this.progCurrentItem.programDashboardId,
      activationDashboardType : 'INTEGRATION',
      integrationType : 'HIRATION',
    }
    this.dashboardService.startIntegration(payload).subscribe((res) => {
      if (res && res.data) {
        this.navigateToNextItem();
      }
    });
  }

  navigateToNextItem() {
    localStorage.setItem('skipOptional', 'true');
    // this.cs.reloadRoute('/dashboard');
    window.location.reload();
  }

  capturePreTestEvents(item) {
    if(this.user && this.prog && item) {
      let eventData = { user: this.user, program: this.prog, item: item }
      if(item.status.started && item.status.progress < 100) {
        this.eventsService.resumePreTestEvent(eventData);
      }
      else if (item.status.progress == 100) {
        this.eventsService.viewFeedbackPreTestEvent(eventData);
      }
      else {
        this.eventsService.startPreTestEvent(eventData);
      }
    }
  }

  capturePostTestEvents(item) {
    if(this.user && this.prog && item) {
      let eventData = { user: this.user, program: this.prog, item: item }
      if(item.status.started && item.status.progress < 100) {
        this.eventsService.resumePostTestEvent(eventData);
      }
      else if (item.status.progress == 100) {
        this.eventsService.viewFeedbackPostTestEvent(eventData);
      }
      else {
        this.eventsService.startPostTestEvent(eventData);
      }
    }
  }

  captureStartCourseEvent(item) {
    try {
      if(this.user && this.program && this.program[0] && item) {
        let eventData = { 'course': item, 'user': this.user, 'program': this.program[0].program };
        this.eventsService.startCourseEvent(eventData);
      }
    } catch (err) {
      console.log(err);
    }
  }

  captureResumeReviseCourseEvent(item) {
    try {
      if(this.user && (this.program && this.program[0]) && item) {
        let eventData = { user: this.user, course: item, activationData: this.program[0] }
        if(item.status.progress == 100) {
          this.eventsService.reviseCourseEvent(eventData);
        }
        else if (item.status.progress < 100) {
          this.eventsService.resumeCourseEvent(eventData);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  captureAttendMasterclassEvent(item) {
    if(this.user && this.prog && item) {
      let eventData = { user: this.user, program: this.prog }
      let masterclass = this.prog.find( x => ((x.type == 'MASTERCLASS') && (x._id == item._id)))
      if(masterclass) {
        eventData['masterclassObj'] = masterclass;
      }
      this.eventsService.attendMasterclassEvent(eventData);
    }
  }

  captureWatchMasterclassVideoEvent(item?) {
    if(this.user && this.prog) {
      let eventData = { user: this.user, program: this.prog }
      let masterclass = this.prog.find( x => (x.type == 'MASTERCLASS') && (x._id == item._id));
      if(masterclass){
        eventData['masterclassObj'] = masterclass;
      }
      this.eventsService.watchMasterclassVideoEvent(eventData);
    }
  }

  captureStopCourseIntroEvent() {
    if(this.user && this.prog) {
      let eventData = { user: this.user, program: this.prog };
      let courseObj = this.prog.find(x => (x.type == 'COURSE') && (x._id == this.modalData._id));
      if(courseObj){
        eventData['courseObj'] = courseObj;
      }
      this.eventsService.stopCourseIntroEvent(eventData);
    }
  }

  masterclassDetailsEvent(e, item) {
    try {
      if(e && this.user && this.prog && item) {
        let eventData = { user: this.user, prog: this.prog, masterclass: item };
        this.eventsService.seeMasterclassDetailsEvent(eventData);
      }
    } catch (err) {
      console.log(err);
    }
  }

  timeLeaveTab = TimeMe.callWhenUserLeaves(function(){
    // this.calculateTimesession(TimeMe.getTimeOnCurrentPageInSeconds())
    TimeMe.resetAllRecordedPageTimes();
    // TimeMe.initialize();
    TimeMe.stopTimer();
  },1000);

  timeOnreturnTab = TimeMe.callWhenUserReturns(function(){
    TimeMe.initialize();
    TimeMe.startTimer();
  });

  setTimeout() {
    clearInterval(intervalID);
    inactivatetime = 0;
    this.userActivity = setTimeout(
      () => {
        this.userInactive.next(undefined);
        this.calculateTimesession(TimeMe.getTimeOnCurrentPageInSeconds());
        TimeMe.resetAllRecordedPageTimes();
        TimeMe.initialize();
        TimeMe.startTimer();

        intervalID = setInterval(()=>{
          inactivatetime= inactivatetime+1;
          if(inactivatetime >= 900){
            clearInterval(intervalID);
            TimeMe.resetAllRecordedPageTimes();
            TimeMe.initialize();
          }
        }, 1000);
      },
      1000*60*2
    );
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearInterval(intervalID);
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  @HostListener('window:blur', ['$event'])
   onBlur(event: FocusEvent): void {
    this.calculateTimesession(TimeMe.getTimeOnCurrentPageInSeconds());
    TimeMe.resetAllRecordedPageTimes();
    TimeMe.stopTimer();
  }

  calculateTimesession(spent_time){
    // console.log(spent_time, 'spent_timespent_time')
    this.setTimetrackingOnDashboardpage(spent_time);
    // let sTime = Math.floor(spent_time / 60);  // time in minutes
    // let sessionBreak = (sTime - (sTime % 5)) / 5; // number of session break time;
    // let testTime = spent_time;
    // for (let i = 0 ; i <= sessionBreak; i ++){
    //   let calcTime = 300;
    //   if(testTime < 300){
    //     calcTime = testTime;
    //   }
    //   testTime = testTime-300;
    //   this.setTimetrackingOnDashboardpage(calcTime);
    // }
  }

  setTimetrackingOnDashboardpage(calcTime){
    if(calcTime > 0){
      if(calcTime > 900){
        this.timeTrackingObj['spentTime'] = 900;
      } else{
        this.timeTrackingObj['spentTime'] = calcTime;
      }
      this.selfDashboardService.saveTimespentOndashboard(this.timeTrackingObj).subscribe(resp => {})
    }
  }

  ngOnDestroy() {
    let token = localStorage.getItem("token");
    if(token){
      this.calculateTimesession(TimeMe.getTimeOnCurrentPageInSeconds())
    }
  }

  navigateToAssessment(item?) {
    if(item && item.isOptionalToComplete && !this.optionalModal && (!item.status.skipOptionalBlock && !item.status.started)) {
      this.optionalModal = true;
      this.progCurrentItem = item;
      return;
    }
    if(item && !item.status.started) {
      let obj = { activationId: this.activationInfo.programActivationId, programDashboardId: item.programDashboardId, activationDashboardType: 'ASSESSMENT', exerciseId: item.exerciseId };
      this.dashboardService.startExercise(obj).subscribe( res => {
        if(res) {
          this.router.navigate([`/benchmarking/assessment/${item.exerciseId}`]);
        }
      })
    } else if(item && item.status.started){
      this.router.navigate([`/benchmarking/assessment/${item.exerciseId}`]);
    }
  }

  skipAssessmentBlock() {
    let obj = { activationId: this.activationInfo.programActivationId, programDashboardId: this.progCurrentItem.programDashboardId, activationDashboardType: 'ASSESSMENT', exerciseId: this.progCurrentItem.exerciseId, skipOptionalBlock: true };
    this.dashboardService.startExercise(obj).subscribe( res => {
      if(res) {
        this.navigateToNextItem();
      }
    });
  }

  startIntegration(path, item?, isIntroVideoPlay?) {
    if(item && item.isOptionalToComplete && !this.optionalModal && (!item.status.skipOptionalBlock && !item.status.started)) {
      this.optionalModal = true;
      this.progCurrentItem = item;
      return;
    }
    if (!item.status.started && !isIntroVideoPlay) {
      this.modalData = item;
      if (item.courseDisableIntroVideo) {
        this.showMobal = false;
      } else {
        this.showMobal = true;
        return;
      }
    }
    let payload = {
      activationId : this.program && this.program.length ? this.program[0].programActivationId : null,
      programDashboardId : item.programDashboardId,
      activationDashboardType : item.type,
      integrationType : item.integration.type,
    }
    if(!item.status.started) {
      this.dashboardService.startIntegration(payload).subscribe((res) => {
        if (res.data) {
          const url = this.router.serializeUrl(
            this.router.createUrlTree([`/${path}`, {pid:payload.activationId, pdid:payload.programDashboardId, org:this.program[0]['organization']}])
          );
          window.open(url, '_blank');
        }
      })
    } else {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/${path}`, {pid:payload.activationId, pdid:payload.programDashboardId,org:this.program[0]['organization']}])
      );
      window.open(url, '_blank');
    }
  }
}
